module.exports = __webpack_public_path__ + "media/images/logo-white-only-4a0e7016ad6b19e17504b476a313f8e5.png";